import {
  addRiskManagementDetailsAPI,
  deleteRiskManagementDetailsAPI,
  getRiskManagementDetailsAPI,
  updateRiskManagementDetailsAPI,
} from "./api";

export const addRiskManagementDetails = (id, data) => {
  return new Promise((resolve, reject) => {
    addRiskManagementDetailsAPI(id, data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const updateRiskManagementDetails = (data) => {
  return new Promise((resolve, reject) => {
    updateRiskManagementDetailsAPI(data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getRiskManagementDetails = (data) => {
  return new Promise((resolve, reject) => {
    getRiskManagementDetailsAPI(data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const deleteRiskManagementDetails = (data) => {
  return new Promise((resolve, reject) => {
    deleteRiskManagementDetailsAPI(data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};